import styled from "styled-components";

import { Button, Icon, Input } from "components/ui";
import { TextArea } from "components/ui/textArea";

import { media } from "constants/media";

export const StyledVacancyForm = styled.div`
    color: var(--color-black);
    height: 100vh;
    overflow-y: scroll;
    padding: 24px 24px 112px;
    position: relative;
    width: 100%;

    ${media.mdUp} {
        padding: 56px 100px 56px 80px;
    }
`;

export const InfoLabelsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    row-gap: 16px;

    ${media.mdUp} {
        column-gap: 26px;
        flex-direction: row;
    }
`;

export const StyledLabel = styled.div`
    align-items: center;
    background-color: var(--color-grey-50);
    border-radius: 16px;
    display: flex;
    font-size: 12px;
    font-weight: 800;
    line-height: 16px;
    padding: 4px 8px;
    text-transform: uppercase;
    width: fit-content;
`;

export const TagItem = styled.div`
    align-items: center;
    display: flex;
    font-size: 12px;
    font-weight: 800;
    line-height: 16px;
    padding: 4px 8px;
    text-transform: uppercase;
    width: fit-content;
`;

export const TagItemIcon = styled(Icon)`
    margin-right: 10px;
`;

export const FormInputsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 32px 0 116px;

    ${media.mdUp} {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 32px;
        margin: 24px 0 64px;
    }
`;

export const StyledInput = styled(Input)`
    margin-bottom: 24px;

    ${media.mdUp} {
        margin-bottom: 0;
        width: calc(50% - 16px);
    }
`;

export const StyledTextArea = styled(TextArea)`
    margin-bottom: 24px;

    ${media.mdUp} {
        margin-bottom: 0;
    }
`;

export const FixedButtonWrapper = styled.div`
    align-items: center;
    background-color: var(--color-white);
    bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: flex-start;
    left: 0;
    margin: 0 auto;
    padding: 16px;
    position: fixed;
    width: 100%;

    ${media.mdUp} {
        all: unset;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
`;

export const RequiredText = styled.span`
    align-self: flex-start;
    font-size: var(--type-sub-text-font-size-sub-text);
    font-style: italic;
    line-height: var(--type-sub-text-line-height);
`;

export const StyledSubmitButton = styled(Button)`
    max-width: 425px;
    white-space: nowrap;
    width: fit-content;

    ${media.mdUp} {
        margin: 0;
        width: fit-content;
    }
`;

export const SuccessBlock = styled.div`
    border: 2px solid var(--color-green-50);
    border-radius: 24px;
    margin-top: 24px;
    padding: 24px;
`;

export const SuccessTitle = styled.div`
    align-items: center;
    display: flex;
    font-size: 16px;
    font-weight: 800;
    line-height: 32px;
    margin-bottom: 16px;

    ${media.mdUp} {
        font-size: 18px;
    }
`;

export const SuccessIcon = styled(Icon)`
    font-size: 18px;
    font-weight: 800;
    line-height: 32px;
    margin-right: 8px;
`;

export const FormErrorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 32px;
`;

export const FormErrorButton = styled(Button)`
    margin-top: 24px;
    width: fit-content;
`;

export const CloseModalButton = styled(Button)`
    margin-right: 16px;
    width: fit-content;

    svg {
        border: 2px solid var(--color-primary);
        border-radius: 50px;
        margin-left: 4px;
    }

    ${media.mdUp} {
        margin: 24px 0 0;
    }
`;

export const Buttons = styled.div`
    display: flex;
    gap: 16px;
    justify-content: space-between;
    width: 100%;
`;

export const IconWrapper = styled.div<{ isMobileView: boolean }>`
    align-items: center;
    background-color: var(--color-black);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    flex-shrink: 0;
    height: 56px;
    justify-content: center;
    transition-duration: var(--default-transition-duration);
    transition-property: background-color;
    transition-timing-function: ease;
    width: 56px;
    z-index: var(--z-index-modal-close-button);

    &:hover {
        background-color: var(--color-orange-40);
    }

    ${media.mdUp} {
        bottom: unset;
        left: -27px;
        top: 62px;
    }
`;
